var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
import { combineLatest, distinctUntilChanged, map } from 'rxjs/operators';
import { toObservable } from './helpers';
var Query = /** @class */ (function () {
    function Query() {
    }
    Query.prototype.where = function (field, condition, value) {
        var newParams = toObservable(value).pipe(distinctUntilChanged(), map(function (v) {
            var param = condition === 'in'
                ? { name: field, condition: condition, values: v }
                : { name: field, condition: condition, value: v };
            return _a = {}, _a[field] = param, _a;
            var _a;
        }));
        if (this.params === undefined) {
            this.params = newParams;
        }
        else {
            this.params = this.params.pipe(combineLatest(newParams, function (params, p) { return Object.assign({}, params, p); }), distinctUntilChanged());
        }
        return this;
    };
    // orderBy(field: string, direction: OrderByDirection = 'asc'): Query<K> {
    //   this.explicitOrderBy = { field, direction };
    //   return this;
    // }
    Query.prototype.limit = function (n) {
        if (this.limitValue) {
            throw new Error("You can't call `limit` twice.");
        }
        this.limitValue = toObservable(n).pipe(distinctUntilChanged());
        return this;
    };
    Object.defineProperty(Query.prototype, "query", {
        get: function () {
            return __assign({}, this.limitValue ? { limit: this.limitValue } : {}, this.offsetValue ? { offset: this.offsetValue } : {}, this.params ? { params: this.params } : {});
        },
        enumerable: true,
        configurable: true
    });
    return Query;
}());
export { Query };



// WEBPACK FOOTER //
// ./src/app/@shared/datastore/query.ts.pre-build-optimizer.js